<container-padrao>
    <div [innerHTML]="htmlRelatorio | safeHtmlRelatorio"></div>

    <!-- <div *ngIf="htmlRelatorio" class="relatorio-body">

        <div class="btn-relatorio w-100 d-grid justify-content-center">
            <a class="cta insights" (click)="recomendacoes()">⭐ Clique para visualizar as Recomendações</a>
        </div>
    </div> -->
</container-padrao>


<container-padrao>
    <loader-page [show]="loading"></loader-page>

    <card title="Materiais para baixar">
        <tabela-listagem [colunas]="colunasTabelaMateriais" [actions]="actionsMateriais"
            [service]="materiaisService"></tabela-listagem>
    </card>
</container-padrao>